import { render, staticRenderFns } from "./transaction-refund-badge.vue?vue&type=template&id=754130e3&scoped=true"
import script from "./transaction-refund-badge.vue?vue&type=script&setup=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&lang=js"
export * from "./transaction-refund-badge.vue?vue&type=script&setup=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754130e3",
  null
  
)

export default component.exports